import { createGlobalStyle } from 'antd-style';

import { ThemeSpaces } from '../theme';

const defineAnimation = (
  name,
  animatedProps,
  start,
  end,
  easing = 'ease-in-out',
  duration
) => ({
  [`.${name}-enter, .${name}-appear`]: start,
  [`.${name}-enter.${name}-enter-active, .${name}-appear.${name}-appear-active`]:
    {
      ...end,
      transition: `${animatedProps} ${duration} ${easing}`,
    },
  [`.${name}-exit, .${name}-leave`]: end,
  [`.${name}-exit.${name}-exit-active, .${name}-leave.${name}-leave-active`]: {
    ...start,
    transition: `${animatedProps} ${duration} ${easing}`,
  },
});

const defineKeyframesAnimation = (name, animationName, duration) => ({
  [`.${name}-enter`]: {
    animationName,
    animationDuration: duration,
    animationPlayState: 'running',
  },
  [`.${name}-enter.${name}-enter-active`]: {
    animationName,
    animationDuration: duration,
    animationPlayState: 'running',
  },
  [`.${name}-exit, .${name}-leave`]: {
    animationName,
    animationDuration: duration,
  },
  [`.${name}-exit.${name}-exit-active, .${name}-leave.${name}-leave-active`]: {
    animationName,
    animationDuration: duration,
    animationFillMode: 'forwards',
  },
});

const AnimationStyles = createGlobalStyle(({ theme }) => ({
  ...defineAnimation(
    'from-right',
    'transform',
    { transform: 'translateX(100%)' },
    { transform: 'none' },
    'ease-in-out',
    theme.motionDurationMid
  ),
  ...defineAnimation(
    'from-left',
    'transform',
    { transform: 'translateX(-100%)' },
    { transform: 'none' },
    'ease-in-out',
    theme.motionDurationMid
  ),
  ...defineAnimation(
    'from-top',
    'transform',
    { transform: 'translateY(-100%)' },
    { transform: 'none' },
    'ease-in-out',
    theme.motionDurationMid
  ),
  ...defineAnimation(
    'from-bottom',
    'transform',
    { transform: 'translateY(100%)' },
    { transform: 'none' },
    'ease-in-out',
    theme.motionDurationMid
  ),
  ...defineAnimation(
    'fade-from-left',
    'all',
    { transform: 'translateX(-100%)', opacity: 0 },
    { transform: 'none', opacity: 1 },
    'ease-in-out',
    theme.motionDurationSlow
  ),
  ...defineAnimation(
    'scale-up',
    'transform',
    { transform: 'scale(0)' },
    { transform: 'scale(1)' },
    'ease-in-out',
    theme.motionDurationMid
  ),
  ...defineKeyframesAnimation(
    'monitor-item-delete',
    'monitor-item-delete',
    '1.4s'
  ),
  '@keyframes monitor-item-delete': {
    '0%': {
      transform: 'scale(1)',
      minHeight: 0,
      maxHeight: 160,
      padding: 0,
      marginBottom: ThemeSpaces.SPACE_NORM,
    },
    '57%': {
      transform: 'scale(0)',
      minHeight: 0,
      maxHeight: 160,
      padding: 0,
      marginBottom: ThemeSpaces.SPACE_NORM,
    },
    '100%': {
      transform: 'scale(0)',
      minHeight: 0,
      maxHeight: 0,
      padding: 0,
      marginBottom: 0,
    },
  },
}));

export default AnimationStyles;
